const types = {
  REFERRAL_LINK_START: 'REFERRAL_LINK_START',
  REFERRAL_LINK_SUCCESS: 'REFERRAL_LINK_SUCCESS',
  REFERRAL_LINK_FAILURE: 'REFERRAL_LINK_FAILURE',

  REFERRAL_JOIN_START: 'REFERRAL_JOIN_START',
  REFERRAL_JOIN_SUCCESS: 'REFERRAL_JOIN_SUCCESS',
  REFERRAL_JOIN_FAILURE: 'REFERRAL_JOIN_FAILURE',

  REFERRAL_TOASTER_SHOW: 'REFERRAL_TOASTER_SHOW',
  REFERRAL_TOASTER_HIDE: 'REFERRAL_TOASTER_HIDE',
};

export default types;
